import moment from 'moment';
export function fetchdayTimes(date) {
  const second = Date.parse(new Date()) - new Date(date).getTime();
  // 计算出相差天数
  const days = Math.floor(second / (24 * 3600 * 1000));
  // 周
  const week = Math.floor(second / (24 * 3600 * 1000 * 7));
  // 月
  const month = Math.floor(second / (24 * 3600 * 1000 * 7 * 4));
  // 年
  const year = Math.floor(second / (24 * 3600 * 1000 * 7 * 4 * 12));
  // 计算出小时数
  const leave1 = second % (24 * 3600 * 1000); // 计算天数后剩余的毫秒数
  const hours = Math.floor(leave1 / (3600 * 1000));
  // 计算相差分钟数
  const leave2 = leave1 % (3600 * 1000); // 计算小时数后剩余的毫秒数
  const minutes = Math.floor(leave2 / (60 * 1000));

  // 计算相差秒数
  const leave3 = leave2 % (60 * 1000); // 计算分钟数后剩余的毫秒数
  const seconds = Math.round(leave3 / 1000);

  let result = '';
  if (year && month && month >= 12) {
    result = `${year}年前`
  } else if (month && week && week >= 4 && month < 12) {
    result = `${month}个月前`
  } else if (days && week && days >= 7 && week < 4) {
    result = `${week}周前`
  } else if (days && days >= 1 && days < 7) {
    result += `${days}天前`;
  } else if (hours && hours >= 1 && hours <= 23) {
    result += `${hours}小时前`;
  } else if (minutes && minutes >= 1 && minutes <= 59) {
    result += `${minutes}分钟前`;
  } else if (seconds && seconds >= 1 && seconds <= 59) {
    result += `${seconds}秒前`;
  } else {
    result = '1秒前';
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/utils/timmer.js